import { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { BUSINESS } from "@/lib/site";

const SECTIONS = [
  { title: "What We Collect", body: "When you use the enquiry form on this website, we collect your name, phone number, the product you are asking about, and your message. When you contact us on WhatsApp, by phone, or by email, we receive the contact details you share with us directly." },
  { title: "How We Use It", body: "We use your details only to respond to your enquiry — to share product prices, stock availability, delivery options, or bulk quotations. Your enquiry is emailed to the store owner and stored securely so we can follow up with you." },
  { title: "What We Never Do", body: "We never sell, rent, or share your contact details with third parties for marketing. We never ask for your passwords, OTPs, or card details through this website, email, or WhatsApp." },
  { title: "Third-Party Services", body: "WhatsApp and call buttons on this site open those services on your own device; their own privacy policies apply. This website itself does not use advertising trackers." },
  { title: "Your Choices", body: "You can ask us to delete your enquiry details at any time by contacting us using the details below." },
  { title: "Contact", body: `For any privacy question, reach us at ${BUSINESS.email} or call/WhatsApp ${BUSINESS.phoneDisplay}.` },
];

export default function Privacy() {
  useEffect(() => { document.title = "Privacy Policy | SUDHEER ELECTRONIC"; }, []);
  return (
    <div className="bg-[#f4f7fa] text-slate-900 antialiased">
      <Navbar />
      <section className="py-16 sm:py-20" data-testid="privacy-page">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-[11px] font-bold text-blue-700 tracking-widest uppercase">Legal</span>
          <h1 className="text-4xl sm:text-5xl font-black text-slate-950 tracking-tight mt-3 mb-4">Privacy Policy</h1>
          <p className="text-sm text-slate-600 mb-10">
            This policy explains how {BUSINESS.name} handles the information you share with us through this website.
          </p>
          <div className="space-y-4">
            {SECTIONS.map((s, i) => (
              <div key={s.title} data-testid={`privacy-section-${i + 1}`} className="p-6 bg-white rounded-xl border border-slate-200">
                <h2 className="text-sm font-bold text-slate-950 mb-2">{s.title}</h2>
                <p className="text-xs text-slate-600 leading-relaxed">{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
